import { createPinia } from 'pinia'
import '@/assets/tailwind.css'
import router from './router'
import App from '@/App.vue'
import { createApp } from 'vue'
// import { createMetaManager } from 'vue-meta'
import HighchartsVue from 'highcharts-vue'
import ErrorHandlerPlugin from '@/globals/ErrorHandlerPlugin'
import Toast from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
const pinia = createPinia()
const app = createApp(App)
app.use(pinia)
// app.use(createMetaManager())

app.use(router)
app.use(Toast, {
  autoClose: 3000,
  position: 'bottom-right'
})
app.use(HighchartsVue)
app.use(ErrorHandlerPlugin)
app.mount('#app')
